export const COMPANY_FORM_GROUP_KEYS = Object.freeze({
  market: ['market'],
  generalData: {
    code: ['generalData', 'code'],
    pib: ['generalData', 'pib'],
    city: ['generalData', 'city'],
    zip: ['generalData', 'zip'],
    address: ['generalData', 'address'],
    email: ['generalData', 'email'],
    emailReceivers: ['generalData', 'emailReceivers'],
    phoneNumber: ['generalData', 'phoneNumber'],
    bankAccount: ['generalData', 'bankAccount'],
    apiKey: ['generalData', 'apiKey'],
    mainCompany: ['generalData', 'mainCompany'],
    country: ['generalData', 'country'],
  },

  applicationSettings: {
    typeOfCompany: ['applicationSettings', 'typeOfCompany'],
    typeOfHr: ['applicationSettings', 'typeOfHr'],
    isHr: ['applicationSettings', 'isHr'],
    isSector: ['applicationSettings', 'isSector'],
    holidayDaysTracker: ['applicationSettings', 'holidayDaysTracker'],
    trackerStartDate: ['applicationSettings', 'trackerStartDate'],
    workFromHomeType: ['applicationSettings', 'workFromHomeType'],
    eInvoice: ['applicationSettings', 'eInvoice'],
    documentReturnType: ['applicationSettings', 'documentReturnType'],
    documentSeparateRequestResponse: [
      'applicationSettings',
      'documentSeparateRequestResponse',
    ],
    foreignWorkPermitTracker: [
      'applicationSettings',
      'foreignWorkPermitTracker',
    ],
    weekendLeaves: ['applicationSettings', 'weekendLeaves'],
    qrInEInvoices: ['applicationSettings', 'qrInEInvoices'],
    showCompanyLogoInDocs: ['applicationSettings', 'showCompanyLogoInDocs'],
    isForEmployees: ['applicationSettings', 'isForEmployees'],
    isHrOfficerSelfApprove: ['applicationSettings', 'isHrOfficerSelfApprove'],
    companyAdminsReceiveHREmails: [
      'applicationSettings',
      'companyAdminsReceiveHREmails',
    ],
    isGrossBonus: ['applicationSettings', 'isGrossBonus'],
    showInternalRefNumber: ['applicationSettings', 'showInternalRefNumber'],
    invoiceProjectEnabled: ['applicationSettings', 'invoiceProjectEnabled'],
    manualPurchaseInvoiceEnabled: [
      'applicationSettings',
      'manualPurchaseInvoiceEnabled',
    ],
    invoiceJournalEnabled: ['applicationSettings', 'invoiceJournalEnabled'],
    salesJournalEnabled: ['applicationSettings', 'salesJournalEnabled'],
    vatNoticeEnabled: ['applicationSettings', 'vatNoticeEnabled'],
    advancedSalesInvoicingEnabled: ['applicationSettings', 'advancedSalesInvoicingEnabled'],
    autoArchiveInvoicesEnabled: [
      'applicationSettings',
      'autoArchiveInvoicesEnabled',
    ],
    autoArchiveAfterMonths: ['applicationSettings', 'autoArchiveAfterMonths'],
    manualArchiveInvoicesEnabled: [
      'applicationSettings',
      'manualArchiveInvoicesEnabled',
    ],
    postedToErpTrackingEnabled: [
      'applicationSettings',
      'postedToErpTrackingEnabled',
    ],
    taxReturnsClientView: ['applicationSettings', 'taxReturnsClientView'],
    ledgerCardsEnabled: ['applicationSettings', 'ledgerCardsEnabled'],
    sefCustomsEnabled: ['applicationSettings', 'sefCustomsEnabled'],
    sefInputVatEnabled: ['applicationSettings', 'sefInputVatEnabled'],
    sefVatRecordingEnabled: ['applicationSettings', 'sefVatRecordingEnabled'],
    sefFiscalBillsEnabled: ['applicationSettings', 'sefFiscalBillsEnabled'],
    isSickLeaveRequest: ['applicationSettings', 'isSickLeaveRequest'],
    timeTracking: ['applicationSettings', 'timeTracking'],
    strictOldHolidayCutoff: ['applicationSettings', 'strictOldHolidayCutoff'],
    holidayFirstPartRequired: [
      'applicationSettings',
      'holidayFirstPartRequired',
    ],
    mfaEnabled: ['applicationSettings', 'mfaEnabled'],
    ssoOnly: ['applicationSettings', 'ssoOnly'],
    ssoTenantId: ['applicationSettings', 'ssoTenantId'],
    ssoAllowedDomains: ['applicationSettings', 'ssoAllowedDomains'],
    toolsEnabled: ['applicationSettings', 'toolsEnabled'],
    calculatorEnabled: ['applicationSettings', 'calculatorEnabled'],
    assistantEnabled: ['applicationSettings', 'assistantEnabled'],
    activityFeedEnabled: ['applicationSettings', 'activityFeedEnabled'],
    timesheetReviewEnabled: [
      'applicationSettings',
      'timesheetReview',
      'enabled',
    ],
  },

  timesheetReviewRules: {
    maxHoursPerDay: [
      'applicationSettings',
      'timesheetReview',
      'rules',
      'maxHoursPerDay',
    ],
    flagOTSameDayAsPublicHoliday: [
      'applicationSettings',
      'timesheetReview',
      'rules',
      'flagOTSameDayAsPublicHoliday',
    ],
    flagNightWithRegularEqFond: [
      'applicationSettings',
      'timesheetReview',
      'rules',
      'flagNightWithRegularEqFond',
    ],
    flagPartialPublicHoliday: [
      'applicationSettings',
      'timesheetReview',
      'rules',
      'flagPartialPublicHoliday',
    ],
    flagUnmarkedOvertime: [
      'applicationSettings',
      'timesheetReview',
      'rules',
      'flagUnmarkedOvertime',
    ],
  },

  timeTrackingSettings: {
    requireApproval: ['timeTrackingSettings', 'requireApproval'],
    autoSyncToPayroll: ['timeTrackingSettings', 'autoSyncToPayroll'],
    defaultBillable: ['timeTrackingSettings', 'defaultBillable'],
    allowTimer: ['timeTrackingSettings', 'allowTimer'],
    maxHoursPerDay: ['timeTrackingSettings', 'maxHoursPerDay'],
    lockAfterApproval: ['timeTrackingSettings', 'lockAfterApproval'],
    attendanceMode: ['timeTrackingSettings', 'attendanceMode'],
  },

  calculationSettings: {
    workTypes: ['calculationSettings', 'workTypes'],
    overTime2: ['calculationSettings', 'overTime2'],
    otherIncome: ['calculationSettings', 'otherIncome'],
    suspension: ['calculationSettings', 'suspension'],
    otherExpenses: ['calculationSettings', 'otherExpenses'],
    bonus: ['calculationSettings', 'bonus'],
    nonMonetaryBenefit: ['calculationSettings', 'nonMonetaryBenefit'],
    extendedAbExport: ['calculationSettings', 'extendedAbExport'],
  },

  salaryCalculationSettings: {
    salaryCalculationType: [
      'salaryCalculationSettings',
      'salaryCalculationType',
    ],
    holidayLeaveConfirmation: [
      'salaryCalculationSettings',
      'holidayLeaveConfirmation',
    ],
    sickLeaveUpTo30Days65Confirmation: [
      'salaryCalculationSettings',
      'sickLeaveUpTo30Days65Confirmation',
    ],
    sickLeaveUpTo30Days100Confirmation: [
      'salaryCalculationSettings',
      'sickLeaveUpTo30Days100Confirmation',
    ],
    paidLeaveConfirmation: [
      'salaryCalculationSettings',
      'paidLeaveConfirmation',
    ],
    publicHolidayConfirmation: [
      'salaryCalculationSettings',
      'publicHolidayConfirmation',
    ],
  },

  ownershipStructure: 'ownershipStructure',

  authorizedRepresentatives: {
    signature: ['authorizedRepresentatives', 'signature'],
  },

  clientsAdminsClients: 'clientsAdmins.clients',
  clientsAdminsClientOfficers: 'clientsAdmins.clientOfficers',
  clientsAdminsEInvoiceOfficers: 'clientsAdmins.eInvoiceOfficers',
  clientsAdminsCompanyAdmins: 'clientsAdmins.companyAdmins',

  allowances: {
    mealAllowance: ['allowances', 'mealAllowance'],
    holidayAllowance: ['allowances', 'holidayAllowance'],
    travelAllowance: ['allowances', 'travelAllowance'],
    workFromHomeAllowance: ['allowances', 'workFromHomeAllowance'],
  },

  currencies: {
    mealAllowanceCurrency: ['currencies', 'mealAllowanceCurrency'],
    holidayAllowanceCurrency: ['currencies', 'holidayAllowanceCurrency'],
    travelAllowanceCurrency: ['currencies', 'travelAllowanceCurrency'],
    workFromHomeAllowanceCurrency: [
      'currencies',
      'workFromHomeAllowanceCurrency',
    ],
  },

  otherAllowances: {
    otherIncome: ['otherAllowances', 'otherIncome'],
    otherExpenses: ['otherAllowances', 'otherExpenses'],
    suspension: ['otherAllowances', 'suspension'],
    bonus: ['otherAllowances', 'bonus'],
    nonMonetaryBenefit: ['otherAllowances', 'nonMonetaryBenefit'],
  },

  bonusVariations: {
    enabled: ['bonusVariations', 'enabled'],
    types: ['bonusVariations', 'types'],
  },

  suspensionVariations: {
    enabled: ['suspensionVariations', 'enabled'],
    types: ['suspensionVariations', 'types'],
  },

  nonMonetaryBenefitVariations: {
    enabled: ['nonMonetaryBenefitVariations', 'enabled'],
    types: ['nonMonetaryBenefitVariations', 'types'],
  },
});

export const COMPANY_GENERAL_DATA_FORM = Object.freeze({
  generalData: {
    code: undefined,
    pib: undefined,
    city: undefined,
    zip: undefined,
    address: undefined,
    email: undefined,
    phoneNumber: undefined,
    bankAccount: {
      part1: undefined,
      part2: undefined,
      part3: undefined,
    },
    apiKey: undefined,
    mainCompany: undefined,
  },

  applicationSettings: {
    typeOfCompany: 'main',
    typeOfHr: 'serbian',
    isHr: false,
    isSector: false,
    holidayDaysTracker: false,
    trackerStartDate: undefined,
    workFromHomeType: '1',
    eInvoice: false,
    documentReturnType: 'pdf',
    documentSeparateRequestResponse: 'regular',
    foreignWorkPermitTracker: false,
    weekendLeaves: false,
    qrInEInvoices: false,
    applicationSettings: false,
    isForEmployees: false,
    companyAdminsReceiveHREmails: false,
    isHrOfficerSelfApprove: false,
    isGrossBonus: false,
    showInternalRefNumber: false,
    // Opt-in: turning it on makes a project mandatory on every approval.
    invoiceProjectEnabled: false,
    // Opt-in: turning it on lets people record purchase documents that never
    // came through SEF — fiscal receipts, import papers, petty cash.
    manualPurchaseInvoiceEnabled: false,
    // Opt-in, and it needs `invoiceProjectEnabled` as well: the book view is a
    // closed month of one project, and closing a month takes editing away from
    // people who had it.
    invoiceJournalEnabled: false,
    // The same book for outgoing invoices. Also decides what the sync keeps, so
    // it stays off until a company asks for it.
    salesJournalEnabled: false,
    // Ours to switch on: the screen files the buyer's notices on input VAT at
    // SEF in the company's name.
    vatNoticeEnabled: false,
    // What the invoice form offers and what is filed at SEF; off until asked for.
    advancedSalesInvoicingEnabled: false,
    // 🚨 The one switch here that defaults ON. Invoices older than two months
    // leave the working screens on their own every night, and that has always
    // been so — this only lets a company stop it. Off for a company whose
    // approvals run late, where archiving hides work still to be done.
    autoArchiveInvoicesEnabled: true,
    // How many months an invoice stays on the working screens before the
    // nightly job archives it. Two is what every company has always had.
    autoArchiveAfterMonths: 2,
    // Defaults ON for the same reason as the switch above: archiving an
    // invoice by hand is something everyone has always been able to do, and
    // this only takes the button away. Off for a company that does not work
    // with an archive at all — with the nightly job off too, the archive
    // screen itself disappears from their menu.
    manualArchiveInvoicesEnabled: true,
    // Off, unlike the two archive switches above. This is our own bookkeeping
    // progress against a client's invoices, not something they have always had
    // — it goes on for the companies whose books we keep and nowhere else.
    postedToErpTrackingEnabled: false,
    // Off until HLB announces the tax returns page to the company.
    taxReturnsClientView: false,
    // Off until HLB opens the ledger cards page for the company.
    ledgerCardsEnabled: false,
    // Off: each one adds daily requests to SEF.
    sefCustomsEnabled: false,
    sefInputVatEnabled: false,
    sefVatRecordingEnabled: false,
    sefFiscalBillsEnabled: false,
    isSickLeaveRequest: false,
    timeTracking: false,
    strictOldHolidayCutoff: false,
    holidayFirstPartRequired: false,
    toolsEnabled: true,
    calculatorEnabled: true,
    assistantEnabled: true,
    // Opt-in, unlike the module gates above — see the note on the schema field.
    activityFeedEnabled: false,
    timesheetReview: {
      enabled: false,
      rules: {
        maxHoursPerDay: 12,
        flagOTSameDayAsPublicHoliday: true,
        flagNightWithRegularEqFond: false,
        flagPartialPublicHoliday: true,
        flagUnmarkedOvertime: false,
      },
    },
  },

  timeTrackingSettings: {
    requireApproval: true,
    autoSyncToPayroll: false,
    defaultBillable: false,
    allowTimer: true,
    maxHoursPerDay: 12,
    lockAfterApproval: true,
    attendanceMode: false,
  },

  calculationSettings: {
    workTypes: undefined,
    overTime2: false,
    otherIncome: true,
    suspension: true,
    otherExpenses: true,
    bonus: true,
    nonMonetaryBenefit: false,
    extendedAbExport: false,
  },

  salaryCalculationSettings: {
    salaryCalculationType: 'average',
    holidayLeaveConfirmation: 'average',
    sickLeaveUpTo30Days65Confirmation: 'average',
    sickLeaveUpTo30Days100Confirmation: 'average',
    paidLeaveConfirmation: 'average',
    publicHolidayConfirmation: 'average',
  },

  authorizedRepresentatives: {
    authorizedPerson: undefined,
    authorizedPersonJmbg: undefined,
    authorizedPersonPassportNumber: undefined,
    signature: {
      typeOfFile: undefined,
      location: undefined,
      originalName: undefined,
    },
  },

  clientsAdmins: {
    clients: [],
    clientOfficers: [],
    eInvoiceOfficers: [],
    companyAdmins: [],
  },

  allowances: {
    mealAllowance: undefined,
    holidayAllowance: undefined,
    travelAllowance: undefined,
    workFromHomeAllowance: undefined,
  },

  currencies: {
    mealAllowanceCurrency: 'rsd',
    holidayAllowanceCurrency: 'rsd',
    travelAllowanceCurrency: 'rsd',
    workFromHomeAllowanceCurrency: 'rsd',
  },

  otherAllowances: {
    otherIncome: 'rsd',
    otherExpenses: 'rsd',
    suspension: 'rsd',
    bonus: 'rsd',
    nonMonetaryBenefit: 'rsd',
  },

  companyDocsSettings: {
    holidayLeave: undefined,
    paidLeave: undefined,
    nonPaidLeave: undefined,
    bonus: undefined,
    suspension: undefined,
    maternityLeave: undefined,
  },

  companyLogo: {
    typeOfFile: undefined,
    location: undefined,
    originalName: undefined,
  },

  bonusVariations: {
    enabled: false,
    types: [],
  },

  suspensionVariations: {
    enabled: false,
    types: [],
  },

  nonMonetaryBenefitVariations: {
    enabled: false,
    types: [],
  },

  ownershipStructure: [],

  separatedRequestDocs: undefined,
  name: undefined,
  companyAdminReceiveHREmails: false,
  emailReceivers: undefined,
  calculationMethodMeal: undefined,
  mealCurrency: 'rsd',
  calculationMethodHoliday: undefined,
  holidayCurrency: 'rsd',
  travelExpenses: undefined,
  travelExpCurrency: 'rsd',
  otherExpensesCurrency: 'rsd',
  suspensionCurrency: 'rsd',
  otherIncomeCurrency: 'rsd',
  bonusCurrency: 'rsd',
  nonMonetaryBenefitCurrency: 'rsd',
  recipient: undefined,
});

// * Company ownership structure form keys
export const COMPANY_OWNERSHIP_STRUCTURE_FORM = Object.freeze({
  type: 'founder',
  name: undefined,
  dateOfBirth: undefined,
  placeOfBirth: undefined,
  countryOfBirth: undefined,
  placeOfResidence: undefined,
  countryOfResidence: undefined,
  addressOfResidence: undefined,
  JMBG: undefined,
  typeOfDocument: undefined,
  numberOfDocument: undefined,
  issuerOfDocument: undefined,
  placeOfIdDocIssue: undefined,
  dateOfIdDocIssue: undefined,
  percentageOfOwnership: undefined,
  // Signature fields for authorized persons
  signature: null,
  useSignatureOnDocs: false,
});
